import { render, staticRenderFns } from "./bigDataOperating.vue?vue&type=template&id=e4b6ca04&scoped=true&"
import script from "./bigDataOperating.vue?vue&type=script&lang=js&"
export * from "./bigDataOperating.vue?vue&type=script&lang=js&"
import style0 from "./bigDataOperating.vue?vue&type=style&index=0&id=e4b6ca04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b6ca04",
  null
  
)

export default component.exports